import { useEffect, useRef } from "react";

export function useNotFirstEffect(...args: Parameters<typeof useEffect>) {
  const isFirst = useRef<boolean>(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    return args[0]();
  }, args[1]);
}
